import { useQuery } from '@apollo/client';

import { GET_DRIVER_DAY_SERVICE_DOCKET } from '../myDay/driverMyDayQueries';

/**
 * The stop StopView shows (route param docketId): from the loaded driver day
 * when it is one of the active run's stops, otherwise loaded by id (another
 * day's or driver's run, or the driver day failed to load). Loaded stops carry
 * `serviceRun { id planned }`, which useDriverDayActions uses for their pages.
 * Returns { docket, isInDriverDay, isLoading, error, refetch }.
 */
const useStopDocket = (day, docketId) => {
	const dayDocket = (docketId && day.sortedDockets.find(item => item.id === docketId)) || null;
	const { data, loading, error, refetch } = useQuery(GET_DRIVER_DAY_SERVICE_DOCKET, {
		variables: { id: docketId },
		skip: !docketId || Boolean(dayDocket) || day.isLoading,
		fetchPolicy: 'cache-and-network',
		errorPolicy: 'all',
	});
	const loadedDocket = data?.getServiceDocket || null;

	return {
		docket: dayDocket || loadedDocket,
		isInDriverDay: Boolean(dayDocket),
		isLoading: !dayDocket && (day.isLoading || (loading && !loadedDocket)),
		error: !dayDocket && !loadedDocket ? error || null : null,
		refetch,
	};
};

export default useStopDocket;
